import 'css-chunksrc/client/scenes/documentUpload/styles.scss';export default {
  "documentUpload": "_documentUpload_1eb6r_1",
  "main": "_main_1eb6r_7",
  "dropZone": "_dropZone_1eb6r_11",
  "icon": "_icon_1eb6r_24",
  "message": "_message_1eb6r_29",
  "loader": "_loader_1eb6r_34"
};